import React from 'react';
import EnhancedDashboard from '@/components/dashboard/EnhancedDashboard';

const DashboardPage = () => {
  return (
    <div className="container-content py-6">
      <EnhancedDashboard />
    </div>
  );
};

export default DashboardPage;